
<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card shadow">
          <img src="@/assets/images/header.jpg" class="card-img-top" alt="">

          <!-- <div class="card-header bg-success">
            <div class="text-center">
              <img src="@/assets/logo-vertical.png" alt height="150" />
              <hr class="border-secondary">
              <div class="h3 text-white-shadow-sm">ตัวแทนประกันชีวิต AML</div>
            </div>
          </div> -->
          <div class="card-body px-4">
            <form action="" class="form-box" @submit.prevent="validateForm" novalidate>
              <FormInput name="AgentId" type="text" label="รหัสสมาชิก (ใส่เฉพาะตัวเลข 8 หลักเท่านั้น ไม่ต้องใส่ AM/AML)" v-model="values.AgentId" placeholder="รหัสสมาชิก"
                @validate="validate" :error="errors.AgentId" formGroupClass="form-group" />
              <FormInput name="Password" type="password" label="รหัสผ่าน" v-model="values.Password" placeholder="รหัสผ่าน"
                @validate="validate" :error="errors.Password" formGroupClass="form-group" />
              <!-- <div class="text-right">
                <router-link :to="{name: 'forgetpassword' }" class="green">ลืมรหัสผ่าน ?</router-link>
              </div> -->
              <div class="text-center mt-3">
                <button type="submit" class="btn btn-primary d-flex m-auto align-items-center" :disabled="IsSubmit">
                  <div>เข้าสู่ระบบ</div>
                  <div v-show="IsSubmit" class="spinner-border spinner-border-sm ml-2" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </button>
                <br>
                <router-link :to="{ name: 'forgetpassword' }">ลืมรหัสผ่าน</router-link>
              </div>
            </form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
        <!-- end row -->
        <div class="text-center">V. {{ appVersion }}</div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>


<script>
import Layout from '@/components/layouts/auth'
import { authComputed } from '@/store/helpers'
import { version } from '@/../package'

export default {
  page: {
    title: 'Log in',
    meta: [{ name: 'description' }],
  },
  components: { Layout },
  name: 'Login',
  data() {
    var yup = this.yup
    return {
      appVersion: version,
      webUrl: process.env.VUE_APP_WEB_URL,
      IsSubmit: false,
      values: {
        AgentId: "",
        Password: "",
      },
      errors: {
        AgentId: "",
        Password: "",
      },
      FormSchema: yup.object().shape({
        AgentId: yup.string().nullable().required(),
        Password: yup.string().min(8).required('กรุณากรอกรหัสผ่าน'),
      })
    };
  },
  mounted() {
  },
  methods: {
    clickLogin() {
      let self = this;
      this.IsSubmit = true;
      self.axios.post(process.env.VUE_APP_OFFICEAPI_URL + '/api/authadmin', self.values)
        .then(function (res) {
          if (res.status == 200) {
            // console.log(res)
            self.$store.commit('setAuth', res.data.token)
            //console.log(self.$store.state.Admin)

            if (self.$store.state.Admin.IsForceChangePwd)
              self.$router.push({ name: 'admin-change-password' });
            else
              self.$router.push({ name: 'home' });

            self.IsSubmit = false;
            // self.$router.push({ name: 'home' })
            // window.location.replace(process.env.VUE_APP_BASE_URL);
          } else {
            self.$swal({
              title: 'Login',
              text: 'รหัสตัวแทนหรือรหัสผ่านไม่ถูกต้อง กรุณาลองใหม่',
              icon: 'warning',
            });
          }
        })
        .catch(function (error) {
          self.$swal({
            title: 'Login',
            text: 'รหัสตัวแทนหรือรหัสผ่านไม่ถูกต้อง กรุณาลองใหม่',
            icon: 'warning',
          });
          self.IsSubmit = false;
          console.log(error);
        });
      // this.$store.commit('setAdmin',true)
      // this.$router.push({name:'profile'})
    },
    validateForm() {
      this.FormSchema
        .validate(this.values, { abortEarly: false })
        .then(() => {
          console.log(this.values)
          this.clickLogin()
        })
        .catch(err => {
          err.inner.forEach(error => {
            this.errors = { ...this.errors, [error.path]: error.message };
          });
        });
    },
    validate(field) {
      this.FormSchema
        .validateAt(field, this.values)
        .then(() => {
          this.errors[field] = "";
        })
        .catch(err => {
          this.errors[err.path] = err.message;
        });
    }
  }
}
</script>


